import {
  attachSortToggleHandler,
  clearFilters,
  renderWithoutResult,
  resetSearchResult,
  resetSelectedFilters,
  resetPagination,
  search,
  searchFilters,
  searchFromQueryString,
  setQuery,
} from "./search";

import {
  hideFilters,
  isListingPage,
  searchForm,
  searchInput,
  shouldRunInitialSearch,
} from "@features/Pages/SearchPage/Scripts/search.setup";

window.addEventListener('load', () => {
  resetSelectedFilters();

  attachSortToggleHandler();

  if (isListingPage) {
    resetPagination();
  }

  // If URL contains a query, use it instead of running the initial empty search
  if (shouldRunInitialSearch && !window.location.search.includes("query=")) {
    setQuery("");
    resetPagination();
    void search(false);
    searchInput.focus();
    return;
  }

  if (window.location.search) {
    void searchFromQueryString(false);
  }

  searchInput.focus();
});

// Event that happens when users browse through their browser history, e.g. use the back button.
window.addEventListener('popstate', (): void => {

  if (window.location.search) {
    void searchFromQueryString(true);
  } else {
    resetSelectedFilters();
    resetSearchResult();
  }

  searchInput.focus();
});

// Event that happens when user submits a search with the form
searchForm.addEventListener("submit", (event: SubmitEvent): void => {
  event.preventDefault();

  resetPagination();
  const q = searchInput.value.trim();
  setQuery(q);

  if (!isListingPage) {
    clearFilters();
    resetSelectedFilters();
  }
  
  window.history.pushState({}, "", `?query=${q}`);

  if (searchInput.value.trim().length > 0) {
    search();
    if (!hideFilters) {
      searchFilters();
    }
  } else if (isListingPage) {
    resetPagination();
    setQuery("");
    window.history.replaceState({}, "", `?query=`);
    search(); // listing page: empty query = default listing
  } else {
    renderWithoutResult();
  }
});
